function countTags(
  items,
  getItemTags = () => [],
) {
  return items.reduce((accumulator, currentValue) => {
    getItemTags(currentValue).forEach((tag) => {
      if (!Object.prototype.hasOwnProperty.call(accumulator, tag)) {
        accumulator[tag] = 0;
      }
      accumulator[tag] += 1;
    });

    return accumulator;
  }, {});
}

export { countTags };
